import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { ScrollPanel } from 'primeng/scrollpanel';
import { Select } from 'primeng/select';
import { LeverandoerOpkraevningPeriodeApi } from '../leverandoer-opkraevning-periode.api';
import { LeverandoerOpkraevningService } from '../leverandoer-opkraevning.service';
import { LeverandoerOpkraevningSearchParams } from './leverandoer-opkraevning-search-params.model';
import { LeverandoerOpkraevningPeriode } from '../leverandoer-opkraevning-periode.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-leverandoer-opkraevning-search',
  imports: [
    ScrollPanel,
    Button,
    Select,
    ReactiveFormsModule,
    InputText,
    Message,
    CheckboxModule,
  ],
  providers: [DatePipe],
  templateUrl: './leverandoer-opkraevning-search.component.html',
  styleUrl: './leverandoer-opkraevning-search.component.css',
})
export class LeverandoerOpkraevningSearchComponent implements OnInit {
  datePipe = inject(DatePipe);
  leverandoerOpkraevningService = inject(LeverandoerOpkraevningService);
  periodeApi = inject(LeverandoerOpkraevningPeriodeApi);
  data = this.leverandoerOpkraevningService.datasource.data;
  perioder = signal<LeverandoerOpkraevningPeriode[]>([]);

  form = new FormGroup({
    regnr: new FormControl(),
    leverandoerOpkraevningPeriodeId: new FormControl(),
    status: new FormControl(),
  });

  async ngOnInit(): Promise<void> {
    const apiResponse = await this.periodeApi.getList({
      sortBy: 'opkraevningsPeriodeFra',
      descending: true,
    });
    this.perioder.set(apiResponse.data);
  }

  onClickSearch() {
    this.leverandoerOpkraevningService.searchLeverandoerOpkraevning({
      ...(this.form.value as LeverandoerOpkraevningSearchParams),
      searchTime: new Date(),
    });
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (
      this.leverandoerOpkraevningService.datasource.isLoaded() &&
      this.data()?.totalRowCount == 0
    );
  });

  statusOptions = [
    { value: 'IkkeSendtTilOpkraevning', text: 'Ikke sendt til opkrævning' },
    { value: 'SendtTilOpkraevning', text: 'Sendt til opkrævning' },
  ];

  periodeOptions = computed(() => {
    const data = this.perioder() || [];
    return data.map(x => ({
      value: x.id,
      text:
        this.datePipe.transform(x.opkraevningsPeriodeFra, 'yyyy-MM-dd') +
        ' - ' +
        this.datePipe.transform(x.opkraevningsPeriodeTil, 'yyyy-MM-dd'),
    }));
  });
}
